import { Component } from "react";

class HelpDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="fixed bottom-16 right-18 bg-white border-2 border-orange rounded-t-2xl rounded-bl-2xl md:w-96 w-9/12 py-4 px-3 text-center">
        <button className="absolute top-0 left-0 rounded-full text-orange flex items-center justify-center p-2" onClick={this.props.handleClose}> <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16.974 16.974"
          className="stroke-current h-3 w-3"
        >
          <g
            transform="translate(-1053.007 -1252.007)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="3"
          >
            <line
              x2="12.731"
              y2="12.731"
              transform="translate(1055.128 1254.128)"
            />
            <line
              x2="12.731"
              y2="12.731"
              transform="translate(1067.859 1254.128) rotate(90)"
            />
          </g>
        </svg></button>
        {this.props.children}{" "}
      </div>
    );
  }
}

export default HelpDialog;
